import {type PersistConfig} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import type {RootState} from './types';

export const persistConfig: PersistConfig<RootState> = {
    key: 'vela-web-portal',
    storage,
    whitelist: ['translationToggle'],
    migrate: (state: any) => {
        return Promise.resolve(state);
    },
    debug: import.meta.env.MODE === 'development',
};
